var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('PageTitle',{attrs:{"title":"Application"}}),_c('ApiDataForm',{attrs:{"data-api":"apps","form-mode":"edit","can-save":"true"},on:{"after-save":_vm.afterSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }